import { createSelector } from "reselect";
import { selectors as requestSelectors } from "redux-request-state";

const apiKeysBase = state => state.marketplace.integrations.apiKeyIntegration.apiKeys;
export const getApiKeys = createSelector( apiKeysBase, apiKeys => apiKeys.data || [] );
export const isLoadingApiKeys = requestSelectors.isLoading( apiKeysBase );
